<template>
  <section class="das-form-container">
    <div class="das-form-group">
      <div class="das-form-group-title">Hồ sơ khách</div>
      <CustomerForm
        ref="CustomerForm"
        :record-data="customer"
        @selectDuplicateCustomer="onSelectDuplicateCustomer"
        @onSelectCustomer="onSelectCustomer"
        @onClearForm="onClearCustomerForm"
      ></CustomerForm>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button
          v-if="customerFormAction == 'create'"
          class="btn primary small"
          @click="onCreateCustomer"
        >
          Tạo
        </button>
        <button
          v-if="
            customerFormAction == 'edit' && !selectedCustomerIsBookingTraveller
          "
          class="btn primary small outline"
          @click="onAddCustomerToBooking"
        >
          Thêm vào đặt phòng
        </button>
        <button
          v-if="
            customerFormAction == 'edit' && selectedCustomerIsBookingTraveller
          "
          class="btn pink small outline"
          @click="onRemoveCustomerFromBooking"
        >
          Xóa khỏi đặt phòng
        </button>
        <button
          v-if="customerFormAction == 'edit'"
          class="btn primary small"
          @click="onUpdateCustomer"
        >
          Cập nhật
        </button>
      </span>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="das-form-group-title">Danh sách khách hàng</div>
      <GridVx
        ref="agGrid"
        :columns="columnDefs"
        :context="context"
        :rows="bookingTravelers"
        :auto-select-first-row="false"
        @doubleClicked="onBookingTravelerSelected"
      ></GridVx>
    </div>
  </section>
</template>
<script>
import CustomerForm from '@/components/resources/customer/CustomerForm.vue'
import { CellRenderCheckbox } from '@/utils/cellRenders'
import { notifyError, notifySuccess } from '@/utils/toast'

import {
  addTravellerApi,
  getTravellerByIdApi,
  updateTravellerApi
} from '@/api/configuration/profile/traveller'
// eslint-disable-next-line no-unused-vars
import { isBase64 } from '@/utils/helper'
export default {
  components: {
    CustomerForm,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox
  },
  props: {
    visible: {
      default: false
    },
    bookingTravelers: {
      default: () => []
    }
  },
  data() {
    return {
      context: null,
      selectedCustomer: null,
      customer: null,
      columnDefs: [
        {
          headerName: 'ID',
          field: 'traveller_id',
          minWidth: 80,
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.mainGuest'),
          field: 'is_master',
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckbox',
          cellClass: 'grid-cell-align-center',
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.lastName'),
          field: 'last_name',
          minWidth: 300
        },
        {
          headerName: this.$t('grid.column.firstName'),
          field: 'first_name',
          minWidth: 300
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          minWidth: 200,
          flex: 1
        }
      ]
    }
  },
  computed: {
    customerFormAction() {
      if (this.selectedCustomer == null) {
        return 'create'
      }
      return 'edit'
    },
    selectedCustomerIsBookingTraveller() {
      if (this.selectedCustomer == null) {
        return false
      }
      const travellerIndex = this.bookingTravelers.findIndex(
        traveller => traveller.traveller_id === this.selectedCustomer.id
      )
      return travellerIndex !== -1
    }
  },
  watch: {
    visible: {
      handler(value) {
        this.$refs.agGrid.gridApi.sizeColumnsToFit()
      }
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  methods: {
    async onFindDuplicateCustomer(phone, number) {
      await this.findDuplicateTraveller(phone, number)
    },
    onRemoveCustomerFromBooking() {
      this.$emit('removeCustomerFromBooking', this.selectedCustomer.id)
    },
    async onBookingTravelerSelected(travelers) {
      const customer = await this.getCustomer(travelers[0].traveller_id)
      if (customer == null) {
        this.$message({
          type: 'error',
          message: 'Đã có lỗi xảy ra khi tìm thông tin khách hàng'
        })
      } else {
        this.selectedCustomer = customer
        this.hydrateCustomerForm(customer)
      }
    },
    hydrateCustomerForm(customer = null, uploadDocument = null, type = null) {
      this.$refs.CustomerForm.hydrateForm(customer, uploadDocument, type)
    },
    async onSelectDuplicateCustomer(duplicate) {
      const customer = await this.getCustomer(duplicate.id)
      if (customer == null) {
        this.$message({
          type: 'error',
          message: 'Đã có lỗi xảy ra khi tìm thông tin khách hàng'
        })
      } else {
        this.selectedCustomer = customer
        this.hydrateCustomerForm(customer)
      }
    },
    onSelectCustomer(customer) {
      this.selectedCustomer = customer
    },
    onClearCustomerForm() {
      this.selectedCustomer = null
      this.hydrateCustomerForm()
    },
    onAddCustomerToBooking() {
      this.$emit('onAddCustomerToBooking', this.selectedCustomer)
      this.selectedCustomer = null
    },
    /** @description Return file from file or base64  */
    async getImageFile(data) {
      if (!data) return
      let fileData
      if (
        typeof data === 'string' &&
        isBase64(data.replace('data:image/png;base64,', ''))
      ) {
        fileData = await fetch(data)
          .then(res => res.blob())
          .then(blob => {
            const file = new File([blob], '', {
              type: 'image/png'
            })
            return file
          })
      } else {
        fileData = data
      }

      return fileData
    },
    async onCreateCustomer() {
      const error = this.$refs.CustomerForm.validateForm()
      if (error != null) {
        notifyError(error, true)
        return
      }
      const payload = this.$refs.CustomerForm.dehydrateForm()
      const formData = new FormData()
      if (payload.uploaded_document_front_file !== null) {
        const tmpFrontImageData = await this.getImageFile(
          payload.uploaded_document_front_file
        )
        formData.append('frontImage', tmpFrontImageData)
        delete payload.uploaded_document_front_file
      }

      if (payload.uploaded_document_back_file !== null) {
        const tmpBackImageData = await this.getImageFile(
          payload.uploaded_document_back_file
        )
        formData.append('backImage', tmpBackImageData)
        delete payload.uploaded_document_back_file
      }
      formData.append('travellerInsertRequest', JSON.stringify(payload))
      const traveller = await this.createCustomer(formData)
      if (traveller) {
        this.selectedCustomer = traveller
        this.hydrateCustomerForm(traveller)
      }
    },
    async createCustomer(payload) {
      const customer = await addTravellerApi(payload)
        .then(res => {
          notifySuccess(res?.message)
          return res?.data
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return null
        })

      return customer
    },
    async onUpdateCustomer() {
      const error = this.$refs.CustomerForm.validateForm()
      if (error != null) {
        notifyError(error, true)
        return
      }
      const payload = this.$refs.CustomerForm.dehydrateForm()
      const formData = new FormData()
      if (payload.uploaded_document_front_file !== null) {
        const tmpFrontImageData = await this.getImageFile(
          payload.uploaded_document_front_file
        )
        formData.append('frontImage', tmpFrontImageData)
        delete payload.uploaded_document_front_file
      }

      if (payload.uploaded_document_back_file !== null) {
        const tmpBackImageData = await this.getImageFile(
          payload.uploaded_document_back_file
        )
        formData.append('backImage', tmpBackImageData)
        delete payload.uploaded_document_back_file
      }
      formData.append('travellerUpdateRequest', JSON.stringify(payload))
      const isSuccess = await this.updateCustomer(
        formData,
        this.selectedCustomer.id
      )
      if (isSuccess) {
        this.$emit('onUpdateCustomer', payload)
        this.hydrateCustomerForm()
        this.selectedCustomer = null
        this.customerFormAction = 'create'
      }
      // this.selectedCustomer = traveller
    },
    async updateCustomer(payload, id) {
      return await updateTravellerApi(payload, id)
        .then(res => {
          const message = res?.data?.message
          notifySuccess(message)
          return true
        })
        .catch(err => {
          const message = err?.response?.data?.message
          notifyError(message)
          return false
        })
    },
    async getCustomer(id) {
      const customer = await getTravellerByIdApi({ id })
        .then(res => {
          return res.data
        })
        .catch(err => {
          notifyError(err?.response?.data?.message)
          return null
        })

      return customer
    },
    changeCheckbox(colName, params, value) {
      const field = params.colDef.field
      if (field === 'is_master') {
        this.$emit('bookingMasterChanged', colName, params, value)
      }
    }
  }
}
</script>
